export const getItem = (key: string): string => {
  let item;
  try {
    item = localStorage.getItem(key);
  } catch (e) {
    // use default value
  }

  return item || '';
};

export const getItemJson = (key: string): any | undefined => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const setItem = (key: string, value: any, stringify = true): void => {
  try {
    localStorage.setItem(key, stringify ? JSON.stringify(value) : value);
  } catch (e) {
    // avoid errors in Safari private mode
  }
};

export const removeItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // avoid errors in Safari private mode
  }
};

export const getEnvString = (key: string): string => {
  const value = process.env[key];
  return value || '';
};

export const getEnvBoolean = (key: string): boolean => {
  const value = process.env[key];
  return value === 'true';
};
